import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69ef39a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-status-select" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "base-status-select-item-label" }
const _hoisted_4 = { class: "base-status-select-item-value" }
const _hoisted_5 = { class: "num" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "条", -1))

import { ref, withDefaults } from 'vue';
import { BaseSvg } from '@/components/base/base-svg/index';
type Item = { label: string; value: number; num: number };


export default /*#__PURE__*/_defineComponent({
  __name: 'biz-status-select',
  props: {
    statusMap: { default: null },
    defaultValue: { default: null }
  },
  emits: ['changeStatus'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;
const showItems = ref([props.defaultValue]);

const onItemClick = (item: Item) => {
  if (showItems.value.includes(item.value)) {
    showItems.value = showItems.value.filter(v => v !== item.value);
  } else if (item.value === null) {
    showItems.value = [item.value];
  } else if (item.value !== null) {
    showItems.value = showItems.value.filter(v => v !== null);
    showItems.value.push(item.value);
  }
  emits('changeStatus', showItems.value);
};
emits('changeStatus', showItems.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusMap, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(
        showItems.value.includes(item.value)
          ? 'base-status-select-item-active'
          : 'base-status-select-item'
      ),
        key: item.value,
        onClick: ($event: any) => (onItemClick(item))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.label), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.num), 1),
          _hoisted_6
        ]),
        _withDirectives(_createVNode(_unref(BaseSvg), {
          class: "base-status-select-item-icon",
          "icon-class": "gouxuan"
        }, null, 512), [
          [_vShow, showItems.value.includes(item.value)]
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})